export default "__VITE_ASSET__BQMVL65G__"